import appStore from '../utils/state';

export default class MainNavButton extends HTMLElement {
  private button: HTMLButtonElement | null = null;
  private panelId: string | null = null;
  private label: HTMLElement | null = null;

  private isActive: boolean = false;

  private unsubscribeFromPanelState: (() => void) | null = null;

  private onClickBound = this.onClick.bind(this);
  private onMouseEnterBound = this.onMouseEnter.bind(this);
  private onMouseLeaveBound = this.onMouseLeave.bind(this);
  private onMainNavUpdateBound = this.onMainNavUpdate.bind(this);

  connectedCallback(): void {
    this.button = this.querySelector('[data-main-nav-button-ref="button"]');
    this.panelId = this.dataset.panelId ?? this.getAttribute('data-panel-id') ?? null;
    this.label = this.querySelector('[data-main-nav-button-ref="label"]');

    this.addEventListeners();
    this.subscribe();
  }

  addEventListeners(): void {
    if (this.button) {
      this.button.addEventListener('click', this.onClickBound);
    }
  }

  removeEventListeners(): void {
    if (this.button) {
      this.button.removeEventListener('click', this.onClickBound);
    }
    // this.removeEventListener('mouseenter', this.onMouseEnterBound);
    // this.removeEventListener('mouseleave', this.onMouseLeaveBound);
  }

  subscribe(): void {
    this.unsubscribeFromPanelState = appStore.subscribeKey('activeMainNavPanelId', this.onMainNavUpdateBound);
  }

  unsubscribe(): void {
    if (this.unsubscribeFromPanelState) {
      this.unsubscribeFromPanelState();
      this.unsubscribeFromPanelState = null;
    }
  }

  onMainNavUpdate(): void {
    const isMainNavOpen = appStore.getState().isMainNavOpen;
    const activeMainNavPanelId = appStore.getState().activeMainNavPanelId;

    this.isActive = Boolean(this.panelId && isMainNavOpen && activeMainNavPanelId === this.panelId);

    if (this.isActive) {
      if (this.button) {
        this.button.classList.remove('main-nav-button-inactive');
        this.button.classList.add('main-nav-button-active');
        this.button.setAttribute('aria-expanded', 'true');
      }
      if (this.label) {
        this.label.classList.add('main-nav-button-label-active');
      }
    } else {
      if (this.button) {
        this.button.classList.remove('main-nav-button-active');
        this.button.classList.add('main-nav-button-inactive');
        this.button.setAttribute('aria-expanded', 'false');
      }
      if (this.label) {
        this.label.classList.remove('main-nav-button-label-active');
      }
    }
  }

  onClick(): void {
    if (!this.panelId) {
      return;
    }

    appStore.actions.toggleMainNav(this.panelId);
  }

  onMouseEnter(): void {
    if (!this.panelId) {
      return;
    }

    appStore.actions.openMainNav(this.panelId);
  }

  onMouseLeave(): void {
    if (!this.panelId) {
      return;
    }

    appStore.actions.closeMainNav();
  }

  disconnectedCallback(): void {
    this.removeEventListeners();
    this.unsubscribe();
  }
}

customElements.define('main-nav-button', MainNavButton);
